import styled from "@emotion/styled"
import { AppBar, Container } from "@mui/material"
import { css } from "@emotion/css"
import { Link } from "react-scroll"
import CustomLink from "../custom-link/custom-link.component"
import CustomImage from "../custom-image/custom-image.component"

const linkTextDesign = css`
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  line-height: ${({ theme }) => theme.typography.pxToRem(19)};
`

export const CustomAppBar = styled(AppBar)`
  transition: 0.3s background-color ease;
  background-color: #fff;
  &.light {
    background-color: ${({ theme }) => theme.palette.secondary.light};
  }
`

export const CustomContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1em;
  padding-bottom: 1em;
`

export const LogoLink = styled(CustomLink)`
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const LogoImg = styled(CustomImage)`
  width: 140px;
  img {
    width: 140px;
    object-fit: contain !important;
  }
  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 85px;
    img {
      width: 85px;
      object-font: contain !important;
    }
  }
`

export const NavItems = styled.div`
  display: flex;
  flex-direction: row;
`

export const NavLink = styled(CustomLink)`
  color: ${({ theme }) => theme.palette.text.content};
  margin: 0 1.4em;
  cursor: pointer;
  transition: 0.3s all ease;

  ${linkTextDesign};

  ${({ theme }) => theme.breakpoints.down("lg")} {
    display: none;
  }
`

export const CustomNavLink = styled(Link)`
  color: ${({ theme }) => theme.palette.text.content};
  margin: 0 1.4em;
  cursor: pointer;
  /* font-weight: 600; */
  transition: 0.3s all ease;

  ${linkTextDesign};

  ${({ theme }) => theme.breakpoints.down("lg")} {
    display: none;
  }

  &.active {
    font-weight: 600 !important;
    color: ${({ theme }) => theme.palette.primary.main} !important;
  }

  &.inactive {
    font-weight: 400;
    color: ${({ theme }) => theme.palette.primary.main};
  }

  &.activeOverview {
    font-weight: 600;
    color: ${({ theme }) => theme.palette.primary.main};
  }

  &.inactiveOverview {
    font-weight: 400;
    color: ${({ theme }) => theme.palette.primary.main};
  }

  &.noDisplay {
    display: none;
  }
`

export const LinkWithHref = styled(CustomLink)`
  color: ${({ theme }) => theme.palette.text.content};
  margin: 0 1.4em;
  cursor: pointer;
  /* font-weight: 600; */
  transition: 0.3s all ease;

  ${linkTextDesign};

  ${({ theme }) => theme.breakpoints.down("lg")} {
    display: none;
  }
`

export const TreezLogo = styled.div`
  min-height: 40px;
  display: flex;
  align-items: center;
  svg:first-child {
    margin: 0 0.5rem;
    ${({ theme }) => theme.breakpoints.up("sm")} {
      margin: 0 1.5rem;
    }
  }
  .treez {
    width: 57px;
    height: 20px;
  }
`
export const LogosWrapper = styled.div`
  display: flex;
  align-items: center;
`
